/*
 * Application Insights JavaScript SDK - Common, 2.8.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { createValueMap } from "@microsoft/applicationinsights-core-js";
export var RequestHeaders = createValueMap({
    requestContextHeader: [0 /* requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* requestContextHeaderLowerCase */, "request-context"]
});
//# sourceMappingURL=RequestResponseHeaders.js.map